import React, {FC, ReactElement} from 'react';
import {SimpleSearchContext, useSimpleSearchContextValue} from './simpleSearchContext';

const SimpleSearchProvider: FC = ({children}): ReactElement => {
    const {Provider} = SimpleSearchContext;
    const searchTabContextValue = useSimpleSearchContextValue();

    return (
        <Provider value={searchTabContextValue}>{children}</Provider>
    );
};

export default SimpleSearchProvider;